import { phoneNumberCountries } from './PhoneNumberCountryDropdown'
import { PhoneNumberCountryProps } from './PhoneNumberCountryDropdown'

export const findCountryOption = (
  countryCode: PhoneNumberCountryProps['value'],
): PhoneNumberCountryProps => phoneNumberCountries.find((option) => option.value === countryCode)!
